import { useLocation, useNavigate } from 'react-router-dom';
import { RegisterForm } from '../components/register-form';
import { useRegister } from '../api/register';
import { paths } from '@/config/paths';
import { useQueryParams } from '@/hooks/shared/use-query-params';
import links from "@/config/links.config";

export function Register() {
  const navigate = useNavigate();
  const redirect = useQueryParams().getQueryParamByKey('redirect');
  const mutation = useRegister({
    mutationConfig: {
      onSuccess: ({ authenticationId }) => {
        navigate(paths.auth.verify.getHref(authenticationId, redirect));
      },
    },
  });

  return (
    <div className="space-y-6 max-w-sm mx-auto px-4">
      <h2 className="text-xl font-semibold">Registrera dig</h2>
      <p>För att använda piggo behöver du ett konto. Vänligen fyll i nedan uppgifter.</p>
      <RegisterForm onSubmit={(data) => mutation.mutate({ data })} />
      <p className="text-xs text-center">
        Genom att fortsätta godkänner du Piggos <a className="underline cursor-pointer" href={`${links.landing}/allmanna-villkor`}>användarvillkor</a> och
        bekräftar att du har läst Piggos <a className="underline cursor-pointer" href={`${links.landing}/integritetspolicy`}>integritetspolicy</a>.
      </p>
    </div>
  );
}
